import{COOKIES as o}from"./constants.js";var r=function(r,t){var n;return!!(null===(n=(t?t.cookies:r()).get(o.REFRESH_TOKEN))||void 0===n?void 0:n.value)};export{r as isAuthenticated};
//# sourceMappingURL=index.js.map
